import { Component, OnInit, Optional, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { UserModel, RoleDescriptionsList, RoleItem } from 'src/app/models/userModel';
import { MfgappsEventService } from 'src/app/services/mfgapps-event.service';
import { TableTemplateComponent } from 'src/app/templates/table-template/table-template.component';
import { ColumnType, TableColumnModel } from 'src/app/templates/table-template/tableModel';

@Component({
  selector: 'app-view-user-roles',
  imports: [MatIconModule, MatProgressSpinnerModule, TableTemplateComponent],
  templateUrl: './view-user-roles.component.html',
  styleUrl: './view-user-roles.component.scss'
})
export class ViewUserRolesComponent implements OnInit {
  @ViewChild(TableTemplateComponent) tableComponent!: TableTemplateComponent
  currentUser!: UserModel;
  currentUserRole!: RoleItem;
  currentUseraccessList = [];
  loader = { isLoading: true, message: 'Loading User Roles...' };
  errorMessage = '';
  columnList: TableColumnModel[] = [
    { name: "company_code", label: "Company Name", type: ColumnType.text, widthPercent: 50 },
    { name: "plant_name", label: "Plant Name", type: ColumnType.text, widthPercent: 25 },
    { name: "shop_name", label: "Shop Name", type: ColumnType.text, widthPercent: 25 }
  ];

  constructor(private readonly eventService: MfgappsEventService, 
    @Optional() private readonly dialogRef: MatDialogRef<ViewUserRolesComponent>) { }

  ngOnInit() {
    this.getUserRolesData();
    //After 100ms, focus on header to remove autofocus on primeng first table cell
    setTimeout(() => document.getElementById("header").focus(), 100);
  }

  async getUserRolesData() {
    try {
      this.currentUser = this.eventService.getActiveAccount();
      this.currentUserRole = RoleDescriptionsList.find(role => role.roleId === this.currentUser.roleId);
      if (!this.currentUserRole) {
        throw new Error(`${this.currentUser.roleName} - role not found`);
      }
      if (!this.currentUser.isSuperAdmin || this.currentUser.accessList.length !== 0) {
        this.currentUseraccessList = this.currentUser.accessList.map(item => ({
          ...item,
          company_code: `${item.company_name} (${item.company_code})`,
          plant_name: item.plant_name ?? 'ALL',
          shop_name: item.shop_name ?? 'ALL'
        }));
      }
      this.resetLoader();
    }
    catch (error) {
      console.info(error);
      this.resetLoader();
      this.errorMessage = 'Error occurred while fetching user roles, Please try again!'
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  resetLoader() {
    this.loader.isLoading = false;
    this.loader.message = '';
  }

  resetError() {
    this.errorMessage = '';
  }
}